<template>
  <!-- 車流推估人流 -->

  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        車流推估人流
      </div>
      <div class="card-body p-2">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin: auto; max-width: 450px; margin-bottom:20px">
          <apexchart
          type="area"
          :options="chartOptions"
          :series="chartSeries"
          ></apexchart>
        </div>
        <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'車流推估人流'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto" >
              <apexchart
                v-if="chartSeries"
                type="area"
                id="chartPop"
                :options="chartOptions"
                :series="chartSeries"
              ></apexchart>
          </div>
        </dialog-modal>
        <div class="chart-description chart-description-btm">
          以分時呈現停車場當日進入的總車輛數推估人流，08時段為08~09時段的預估人流。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");
import { postVehicleInTimeIntervalPerHour } from "../../api/eastCoastDataApi/ElkQuery/VehicleElk";
export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  props: ["selectedScenicAreaId"],
  data() {
    return {
      dataInterval: null,
      viewPort: window.innerWidth,
      isShortView:false,
      vehicleData: [],
      chartSeries: [],
      chartOptions: {
        chart: {
          // height: 300,
          stacked: true, // 啟用堆疊
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            // format:'HH',
            datetimeUTC: false,
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },
          tooltip: {
            enabled:false,
          },
          categories: [],
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        tooltip: {
          x: {
            format: "MM dd:HH",
            formatter:undefined
          },
          y: {
            formatter: function (val) {
              return val + "人";
            },
            title:{
              formatter:function(){
                return "";
              }
            }
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE_FIVE,
        markers: {
          size: 0,
          hover: {
            size: 3, // 滑鼠懸停時圓點的大小
          },
        },
      },
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },

    removeNegativeAndDecimal(value) {
      //若 value < 0 則回傳 0，若value > 0 則回傳四捨五入後的整數
      return value < 0 ? 0 : Math.round(value)
    },
    drawChart() {
      const vehicleData = this.GetVehiclePeopleData();
      let newOptions = { ...this.chartOptions };
  
      newOptions.tooltip.y.formatter = function (val) {  
          return ` 總計： ${val} 人`
      }
      this.chartSeries = [
        {
          data: vehicleData,
        },
      ];
      const startDate = moment().startOf("day"); // 獲取當天的開始時間，即午夜 00:00
      const dataLength = 24;
      const categories = [];

      for (let i = 0; i < dataLength; i++) {
        const hour = moment(startDate).add(i, "hours").format("HH:mm");
        const date = moment(startDate).format("YYYY-MM-DD");
        const category = `${date} ${hour}`;
        categories.push(category);
      }
            // console.log(categories);
      newOptions.xaxis.categories = categories;
      newOptions.tooltip.x.formatter = function (val) {
        return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} `;
      };
      newOptions.chart.toolbar.export = {
        csv: {
          filename: `${
            this.selectedScenicAreaName
          }_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
        svg: {
          filename: `${
            this.selectedScenicAreaName
          }_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
        png: {
          filename: `${
            this.selectedScenicAreaName
          }_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
      };
      this.chartOptions = newOptions;
    },
    GetVehiclePeopleData() {
      let data = [...this.vehicleData];
      let series =[];
      //將data 裡面所有 totalPeopleFlow 的值，都推入 series陣列中
      data.forEach((current) => {
        series.push(this.removeNegativeAndDecimal(current.totalPeopleFlow),
        );
      });
       //如果 filledSeries.data 長度不足 24，使用 0 填補剩餘的部分  
        const dataLength = series.length;
        const filledData =
          dataLength < 24
            ? series.concat(Array(24 - dataLength).fill(0))
            : item;
            console.log("filledData",filledData);

            const filledSeries = filledData;
  
      console.log("filledSeries",filledSeries);
      return  filledSeries;
    },
    async GetVehicleInTimeIntervalPerHour() {
      let condition = {
        areas: [this.selectedScenicAreaId],
        // sttime: moment().subtract(23, "hours"),
        // endtime: moment(),
        // sttime: moment('2023-04-02').subtract(11, 'hours'),
        // endtime: moment('2023-04-02'),
        // sttime: moment('2025-02-05').startOf("day").format(),
        // endtime: moment('2025-02-05T16:00:00+08:00').format(),


        // sttime: moment("2023-04-01").startOf("day"),
        // endtime: moment("2023-04-01").endOf("day").subtract(10, "hour"), //測試用切割時間
        sttime:  moment().startOf("day").format(),
        endtime: moment().format(), //取得當日最早時間與當下最近小時
        interval: "hour",
      };
      let response = await postVehicleInTimeIntervalPerHour(condition);

      return response.data;
    },
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    selectedScenicAreaName() {
      return Utils.getSingleScenicAreaNamebyId(this.selectedScenicAreaId);
    },
  },
  watch: {
    vehicleData() {
      this.drawChart();
    },
    async selectedScenicAreaId() {
      this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
  },
  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);

    if (this.vehicleData?.length == 0) {
      this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    } else {
      this.drawChart();
    }

    this.dataInterval = setInterval(async () => {
      this.vehicleData = await this.GetVehicleInTimeIntervalPerHour();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
